import { useAnimations, useGLTF } from "@react-three/drei";
import { useEffect } from "react";
import { useEntityAnimationStateManager } from "../../stores/useEntityAnimationStateManager";
import * as THREE from "three";

export const EntityStates = {
  IDLE: "IDLE",
  WAIT: "WAIT",
  PATROL: "PATROL",
  CHASE: "CHASE",
  CAST_SPELL: "CAST_SPELL",
  SEARCH: "SEARCH",
  RETURN: "RETURN",
  RECIEVE_HIT: "RECIEVE_HIT",
  RELEASE: "RELEASE",
} as const;

export type EntityState = keyof typeof EntityStates;

const Entity = () => {
  const model = useGLTF("/models/actors/entity.gltf");
  const { actions } = useAnimations(model.animations, model.scene);

  /**
   * Character animations setup
   */
  const curAnimation = useEntityAnimationStateManager(
    (state: any) => state.curAnimation
  );
  const resetAnimation = useEntityAnimationStateManager(
    (state: any) => state.reset
  );
  const initializeAnimationSet = useEntityAnimationStateManager(
    (state: any) => state.initializeAnimationSet
  );

  // Rename your character animations here
  const animationSet = {
    idle: "Idle_Weapon",
    walk: "Walk",
    run: "Run",
    castSpell: "Spell1",
    recieveHit: "RecieveHit_Attacking",
    release: "Death",
  };

  useEffect(() => {
    // Initialize animation set
    initializeAnimationSet(animationSet);

    // Receive and cast Shadows
    model.scene.traverse((child) => {
      if (
        child instanceof THREE.Mesh &&
        child.material instanceof THREE.MeshStandardMaterial
      ) {
        child.receiveShadow = true;
        child.castShadow = true;
      }
    });
  }, []);

  useEffect(() => {
    // Play animation
    const action = actions[curAnimation ? curAnimation : animationSet.idle];

    // For recieve hit and release animation, only play once and clamp when finish
    if (
      curAnimation === animationSet.recieveHit ||
      curAnimation === animationSet.release
    ) {
      action!
        .reset()
        .fadeIn(0.2)
        .setLoop(THREE.LoopOnce, undefined as unknown as number)
        .play();
      action!.clampWhenFinished = true;
    } else {
      action!.reset().fadeIn(0.2).play();
    }

    // When any action is clamp and finished reset animation
    (action as any)._mixer.addEventListener("finished", () => resetAnimation());

    return () => {
      // Fade out previous action
      action!.fadeOut(0.2);

      // Clean up mixer listener, and empty the _listeners array
      (action as any)._mixer.removeEventListener("finished", () =>
        resetAnimation()
      );
      (action as any)._mixer._listeners = [];
    };
  }, [
    actions,
    animationSet.idle,
    animationSet.recieveHit,
    animationSet.release,
    curAnimation,
    resetAnimation,
  ]);

  return (
    <>
      <primitive object={model.scene} scale={2} position={[0, -2.85, -0.17]} />
    </>
  );
};

export default Entity;
